import { Component, input, InputSignal, output } from '@angular/core';
import { UserTeamPickerComponent } from '../../../../Common/User-Pickers/user-team-picker.component';
import { UserPickerComponent } from '../../../../Common/User-Pickers/user.picker.component';
import { TeamPickerComponent } from '../../../../Team/teamPicker.component';
import { WsTypeaheadModule } from '../../../../UI-Lib/Typeahead/typeahead.module';
import { ActionViewPickerItem } from '../../actionView.models';

@Component({
    selector: 'multi-user-team-picker',
    templateUrl: './multiUserTeamPicker.component.html',
    imports: [WsTypeaheadModule, TeamPickerComponent, UserPickerComponent, UserTeamPickerComponent],
})
export class MultiUserTeamPickerComponent {
    toBePickedArray: InputSignal<ActionViewPickerItem[]> = input<ActionViewPickerItem[]>([]);
    teamOnly: InputSignal<boolean> = input<boolean>(false);
    userOnly: InputSignal<boolean> = input<boolean>(false);
    includeInactiveContacts: InputSignal<boolean> = input<boolean>(false);

    toBePickedArrayChange = output<ActionViewPickerItem[]>();

    addItem(): void {
        this.toBePickedArrayChange.emit([...this.toBePickedArray(), {}]);
    }

    removeItem(index: number): void {
        this.toBePickedArrayChange.emit(this.toBePickedArray().filter((_, itemIndex) => itemIndex !== index));
    }

    contactChanged(newContact: Core.ContactModel, index: number): void {
        this.toBePickedArrayChange.emit(
            this.toBePickedArray().map((item, itemIndex) =>
                itemIndex === index
                    ? {
                          ...item,
                          contactID: newContact.contactID,
                          userID: String(newContact.userID),
                          name: `${newContact.firstName} ${newContact.lastName}`.trim(),
                      }
                    : item,
            ),
        );
    }
}
